import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';
import { CateringBeverageForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/CateringBeverageForm';
import { CateringMealForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/CateringMealForm';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { GenericExternalPageFestival } from '@/ui/pages/external/festival/components/GenericExternalPageFestival';
import { useExternalSubmitAnswer } from '@/ui/pages/external/hooks/useExternalSubmitAnswer';

export function ArtistsCatering() {
  return (
    <GenericExternalPageFestival>
      <Form />
    </GenericExternalPageFestival>
  );
}
function Form({ readOnly = false }: { readOnly?: boolean }) {
  const { onDelete, onSubmit, onEdit } = useExternalSubmitAnswer();

  const sector = 'ARTISTS';

  const panelOpen = !readOnly;
  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: panelOpen, hideCompleted: false }}
    >
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.CATERING}`)}
      />
      <CateringMealForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <CateringBeverageForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
    </ImpactQuestionContext.Provider>
  );
}
